import { LoadingOverlay } from '@mantine/core';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useFetchAssets } from 'src/Hooks/Queries/useFetchAssets';

import { Props } from './RequireOnboarding.types';

const RequireOnboarding = ({ children }: Props) => {
  const { data: assets, isFetching: isAssetsLoading } = useFetchAssets();

  const navigate = useNavigate();

  useEffect(() => {
    if (!isAssetsLoading && assets?.length === 0) {
      navigate('/onboarding');
    }
  }, [assets, navigate]);

  return (
    <>
      <LoadingOverlay
        visible={isAssetsLoading || assets?.length === 0}
        zIndex={1000}
        overlayProps={{ radius: 'sm', blur: 2 }}
      />
      {(assets?.length ?? 0) > 0 && children}
    </>
  );
};

export default RequireOnboarding;
